module.exports = __webpack_public_path__ + "static/media/Layer.fa6c230b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Layer.png
// module id = 52
// module chunks = 0